module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kardometer","start_url":"/","background_color":"#111214","theme_color":"#00A2FF","icon":"src/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"b94dc82c90b373b10d9a0570bdab91c2"},
    }]
